import React from 'react';
import CookieManager from './CookieManager';

const CookieContext = React.createContext<CookieManager | void>(undefined); // eslint-disable-line no-undefined

export default CookieContext;
